import React from 'react';
import { FaFileAlt } from 'react-icons/fa';

import { Container } from './styles';

interface ITextProps {
  iconSize?: number;
}

const Text: React.FC<ITextProps> = ({ iconSize }) => {
  return (
    <Container>
      <FaFileAlt size={iconSize !== undefined ? iconSize : 60} />
    </Container>
  );
};

export default Text;
